import React from 'react';
import emptyStateImage from '../../../../assets/images/emptytstate.svg';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center vamos-white h-[calc(100vh-64px)]">
      <img
        src={emptyStateImage}
        alt="404 no page found"
        className="mb-4"
      />
      <h2 className="text-2xl font-bold text-center text-vamos-gray mb-1">
        404
      </h2>
      <p className="text-center text-vamos-gray">
        We can&#39;t find that page.
      </p>
    </div>
  );
};

export default NotFound;
